import { useEffect } from 'react';

import i18next from 'i18next';
import { Link } from 'react-router-dom';

import routes from 'constants/routes';
import {
  isDepositSymbolEnabledSelector,
  lowBalanceErrorSelector,
  quantityInputDropdownValue,
  quantityInputErrorMessageSelector,
  quantityInputHasAPIErrorSelector,
  quantityInputHasErrorSelector,
  quantityInputValue,
  quantityInputValueInContract,
  sideSelection,
} from 'selectors/placeOrderSelector';
import { selectedProductSelector } from 'selectors/tradeSelectors';
import { useAppDispatch, useAppSelector } from 'storeHooks';
import { OrderPlacementRightArrow } from 'styles/assets/icons';

import handleError, { resetErrors } from './handleErrors.thunk';
import styles from './QuantityInput.module.scss';

const insufficientBalanceMessage = i18next.t('trading:insufficientBalance');
const insufficientQuantityMessage = i18next.t('trading:insufficientQuantity');
const tradingDepositMessage = i18next.t('trading:deposit');

const Errors = ({ hasUserTyped }) => {
  const dispatch = useAppDispatch();
  const quantityInputHasError = useAppSelector(quantityInputHasErrorSelector);
  const quantityInputErrorMessage = useAppSelector(quantityInputErrorMessageSelector);
  const showLowBalanceMessage = useAppSelector(lowBalanceErrorSelector);
  const selectedDropdown = useAppSelector(quantityInputDropdownValue);
  const side = useAppSelector(sideSelection);
  const qtyInput = useAppSelector(quantityInputValue);
  const inputValue = useAppSelector(quantityInputValueInContract);
  const selectedProduct = useAppSelector(selectedProductSelector);
  const contractType = selectedProduct?.contract_type;

  const { isDepositEnabled, depositSymbol } = useAppSelector(
    isDepositSymbolEnabledSelector
  );
  const quantityHasAPIError = useAppSelector(quantityInputHasAPIErrorSelector);

  useEffect(() => {
    // if selected product changes reset errors
    dispatch(resetErrors());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, selectedProduct, inputValue]);

  useEffect(() => {
    dispatch(handleError(inputValue, selectedDropdown, side, false, hasUserTyped));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractType, qtyInput, inputValue, selectedDropdown, hasUserTyped]);

  if (showLowBalanceMessage && !quantityHasAPIError) {
    return (
      (<div
        className="flex-set align-items-center mt-1"
        data-testid="insufficient-balance-error"
        data-palette="Errors">
        <div className={styles.text}>
          {selectedProduct?.contract_type === 'tracker' && side === 'sell'
            ? insufficientQuantityMessage
            : insufficientBalanceMessage}
          .
        </div>
        {isDepositEnabled ? (
          <Link
            to={`${routes.account.deposit}/${depositSymbol}`}
            className={styles.deposit}
          >
            {tradingDepositMessage}{' '}
            <span className={styles.arrow}>
              <OrderPlacementRightArrow />
            </span>
          </Link>
        ) : null}
      </div>)
    );
  }

  if (quantityInputHasError && quantityInputErrorMessage?.length > 0) {
    return (
      (<div
        data-testid="orderSectionErrorMsg"
        className={styles.text}
        data-palette="Errors">
        {quantityInputErrorMessage}
      </div>)
    );
  }

  return null;
};

export default Errors;
